const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

document.documentElement.classList.add('shop-polish-ready');

const header = document.querySelector('#header-component');

const updateHeaderState = () => {
  if (!header) return;

  header.classList.toggle('is-scrolled', window.scrollY > 12);
};

updateHeaderState();
window.addEventListener('scroll', updateHeaderState, { passive: true });

if (!prefersReducedMotion && 'IntersectionObserver' in window) {
  const isMobileViewport = window.matchMedia('(max-width: 749px)').matches;
  const revealSelectors = [
    'main > .shopify-section',
    '.product-details > .group-block > .group-block-content > *',
    '.engraving-customizer__panel',
    ...(!isMobileViewport ? ['.product-card', '.resource-card'] : []),
  ];

  const revealItems = Array.from(document.querySelectorAll(revealSelectors.join(','))).filter(
    (item) => item instanceof HTMLElement && !item.closest('#header-group, footer')
  );

  const revealObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.08,
    }
  );

  revealItems.forEach((item, index) => {
    item.classList.add('shop-reveal');
    item.style.setProperty('--reveal-delay', `${Math.min(index % 6, 5) * 45}ms`);
    revealObserver.observe(item);
  });
}
